import qs from 'qs'

const formatActionPayload = (routeMatch, url) => {
  const decodeDoubleEncodedCommas = str => (str ? str.replace(/%252C/g, '%2C') : str)

  const decodeParams = obj => {
    const newObj = {}
    Object.keys(obj).forEach(key => {
      newObj[key] = decodeDoubleEncodedCommas(obj[key])
    })

    return newObj
  }

  const getQueryStringParams = url => {
    if (url.split('?').length === 1) {
      return {}
    }

    const queryString = url.split('?')[1]

    return qs.parse(queryString)
  }

  return {
    params: decodeParams(routeMatch.params),
    path: decodeDoubleEncodedCommas(routeMatch.url),
    query: getQueryStringParams(url)
  }
}

export const isSearchOrCannedOrSd = pageType => {
  return pageType === 'search' || pageType === 'canned' || pageType === 'directory'
}

export default formatActionPayload
